import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { useSite } from "@/context/SiteContext";
import { IMG } from "@/lib/content";
import { Reveal, Placeholder } from "@/components/kit";
import { Timeline } from "@/components/Timeline";

export default function MaLeba() {
  useSeo("Ma Leba — hommage et histoire", "Hommage à Ma Leba, l'âme et l'inspiration de l'ONG MA LEBA et de l'ASSOCIATION MA LEBA.");
  const { settings } = useSite();
  const m = settings?.maleba || {};
  return (
    <div data-testid="maleba-page">
      <section className="relative overflow-hidden bg-[#0f1412] text-white">
        <div className="absolute inset-0 pagne-light" />
        <div className="container-x relative grid gap-10 py-16 lg:grid-cols-2 lg:items-center lg:py-24">
          <div>
            <p className="fade-up font-display text-sm font-semibold uppercase tracking-[0.25em] text-gold">Hommage</p>
            <h1 className="fade-up mt-3 font-display text-5xl font-bold uppercase leading-none sm:text-6xl lg:text-7xl" style={{ animationDelay: ".1s" }}>Ma Leba</h1>
            <p className="fade-up mt-6 border-l-2 border-gold pl-4 text-xl italic text-white/85" style={{ animationDelay: ".2s" }} data-testid="maleba-hommage">{m.hommage}</p>
            {m.quote && <blockquote className="mt-6 font-display text-2xl uppercase text-gold">« {m.quote} »</blockquote>}
          </div>
          <div className="fade-in relative w-full max-w-md justify-self-center lg:justify-self-end">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_60%,rgba(224,168,46,0.3),transparent_68%)]" aria-hidden="true" />
            <img src={IMG.maleba} alt="Portrait de Ma Leba" className="relative w-full drop-shadow-2xl" data-testid="maleba-photo" />
          </div>
        </div>
      </section>
      <section className="pagne py-20">
        <div className="container-x grid gap-12 lg:grid-cols-2">
          <Reveal>
            <h2 className="h2">Qui était Ma Leba ?</h2>
            <Placeholder text={m.who_text} className="mt-6 text-lg text-neutral-700" />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="h2">Son histoire, notre inspiration</h2>
            <Placeholder text={m.story_text} className="mt-6 text-lg text-neutral-700" />
          </Reveal>
        </div>
        <div className="container-x mt-16 flex flex-wrap gap-3">
          <Link to="/ong" className="btn bg-ong text-white hover:bg-[#165c27]" data-testid="maleba-link-ong">Découvrir l'ONG</Link>
          <Link to="/association" className="btn bg-asso text-white hover:bg-[#a31016]" data-testid="maleba-link-association">Découvrir l'Association</Link>
        </div>
      </section>
      <Timeline steps={m.timeline} />
    </div>
  );
}
